import gql from 'graphql-tag';

export default gql`
  mutation poOrderFile($input: PoOrderFileInput!) {
    poOrderFile(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
